import comp from "./EventBody";
export default comp;
